import { CircleDollarSign, Video } from "lucide-react";

import { AdvertisingEnum } from "@/src/types/advertisings";

import type { LucideIcon } from "lucide-react";

export const ADVERTISING_TYPE_ICONS = {
  [AdvertisingEnum.CSAI_MP4]: Video,
  [AdvertisingEnum.CSAI_VAST]: CircleDollarSign,
} as const satisfies Record<AdvertisingEnum, LucideIcon>;
